"use client";
import MYdata from "@/app/data/privacy/terms.json";

function hero() {
  const data = MYdata[0];
  return (
    <div>
      <div style={{ background: "rgba(213, 175, 52, 0.1)" }}>
        <div className="mx-auto max-w-7xl pt-4 pb-4 px-6">
          <h1 className="text-4xl mb-2 font-bold secondary">{data.title}</h1>
        </div>
      </div>
      <div className="mx-auto max-w-7xl mb-10 px-6">
        <div
          dangerouslySetInnerHTML={{ __html: data?.des }}
          className="updatedparapremu pt-4 mb-4"
        ></div>
        {data.terms_and_conditions.map((Object, index) => (
          <div key={index}>
            <h2 className="updatedheading pb-2">{Object.title}</h2>
            <div
              dangerouslySetInnerHTML={{ __html: Object?.content }}
              className="updatedparapremu mb-2"
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default hero;
